import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './delete.less'
import { Link } from 'react-router'
import { formatMoney } from 'client/griffin'
import { glimpseRoute } from 'lib/route_utils'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES
const i18n = getI18n('components/edit_glimpse/edit_delete')

class Delete extends React.Component {
  static propTypes = {
    moneyBoxAmount: PropTypes.number,
    currency: PropTypes.string,
    campaignType: PropTypes.string,
  }

  render() {
    let title, description
    if (this.props.moneyBoxAmount) {
      const formattedMoneyboxAmount = formatMoney(
        this.props.currency,
        this.props.moneyBoxAmount
      )
      title = i18n('title_moneybox', { amount: formattedMoneyboxAmount })
      description =
        this.props.campaignType === CROWD_FUNDING
          ? i18n('delete_description_moneybox_cf')
          : i18n('delete_description_moneybox')
    } else {
      title = i18n('title')
      description =
        this.props.campaignType === CROWD_FUNDING
          ? i18n('delete_description_cf')
          : i18n('delete_description')
    }

    return (
      <div>
        <span
          className="icon icon-large icon-attention-large"
          styleName="delete-indicator"
          aria-hidden="true"
        />
        <div styleName="title" role="heading" aria-level="1">
          {title}
        </div>
        <div styleName="description">
          <p>{description}</p>
        </div>
        <Link
          to={glimpseRoute('edit', 'delete/review')}
          data-nemo="deleteButton"
          className="vx_btn vx_btn-block"
          styleName="delete-button"
        >
          {this.props.campaignType === CROWD_FUNDING
            ? i18n('delete_action_cf')
            : i18n('delete_action')}
        </Link>
      </div>
    )
  }
}

export default cssModules(Delete, styles)
